<template>
    <div class="pay-fee-result">
        <!-- 查询结果 s-->
        <section class="ui-collapsible express-list">
            <div id="rateListTH" class="ui-collapsible-heading">
                <ul class="express-type-freight express-type-freight-arrive clearfix">
                    <li class="type">{{ _ll('产品类型') }}</li>
                    <li class="type">{{ _ll('重量') }}</li>
                    <li class="type">{{ _ll('预计到达时间') }}</li>
                    <li v-if="showDeliverFreight" id="originFreight" class="type" @click="showDeliverFreight = false">
                        {{ _ll('寄付价') }}
                        <div class="cursor">
                            <span class="sfi icon-pay-conver">{{ _ll('到付换算') }}</span>
                        </div>
                    </li>
                    <li v-else id="destFreight" class="type" @click="showDeliverFreight = true">
                        {{ _ll('到付价') }}
                        <div class="cursor">
                            <span class="sfi icon-pay-conver">{{ _ll('寄付换算') }}</span>
                        </div>
                    </li>
                </ul>
            </div>
            <ul id="rateList" class="function-list">
                <!--国内流向产品展示-->
                <div v-if="domesticRateInfoArr.length > 0">
                    <pay-fee-domestic
                        v-for="rateInfo in domesticRateInfoArr"
                        :key="rateInfo.limitTypeCode"
                        :rateInfo="rateInfo"
                        :showDeliverFreight="showDeliverFreight"
                    />
                </div>

                <!--国际流向产品展示-->
                <div v-if="internRateInfoArr.length > 0">
                    <pay-fee-international
                        v-for="rateInfo in internRateInfoArr"
                        :key="rateInfo.limitTypeCode"
                        :rateInfo="rateInfo"
                        :showDeliverFreight="showDeliverFreight"
                    />
                </div>

                <overdue-refund v-if="showOverdueRefund" />
                <the-earlier-the-cheaper v-if="showTheEarlierTheCheaper" />
                <!--默认时效产品-->
                <pay-fee-default-product v-if="showDefaultProduct" />
            </ul>
        </section>

        <!-- 查询结果 e-->
        <div id="loading" class="dialog-tips" style="display: none">
            <div class="content">{{ _ll('正在处理您的请求，请稍后') }}</div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import PayFeeDomestic from './pay-fee-domestic'
import PayFeeInternational from './pay-fee-international'
import OverdueRefund from './additionalService/overdue-refund'
import TheEarlierTheCheaper from './additionalService/the-earlier-the-cheaper'
import PayFeeDefaultProduct from './pay-fee-default-product'
export default {
    name: 'PayFeeResult',
    components: {
        PayFeeDomestic,
        PayFeeInternational,
        OverdueRefund,
        TheEarlierTheCheaper,
        PayFeeDefaultProduct
    },
    data() {
        return {
            showDeliverFreight: true // 是否显示寄付价，默认true
        }
    },
    computed: {
        ...mapState('payFee', ['rateInfoArr', 'showDefaultProduct']),

        /**
         * 国内的运费时效数据
         * @return {Array}
         */
        domesticRateInfoArr: function () {
            // eslint-disable-next-line no-undef
            return _.filter(this.rateInfoArr, rate => !rate.internet)
        },

        /**
         * 国外的运费时效数据
         * @return {Array}
         */
        internRateInfoArr: function () {
            // eslint-disable-next-line no-undef
            return _.filter(this.rateInfoArr, rate => rate.internet)
        },

        /**
         * 是否显示“超时退费”的说明
         * @return {boolean}
         */
        showOverdueRefund: function () {
            // eslint-disable-next-line no-undef
            return _.filter(this.domesticRateInfoArr, rate => rate.limitTypeCode === 'T104' || rate.limitTypeCode === 'T801').length > 0
        },

        /**
         * 是否显示“越早寄越优惠”的说明
         * @return {boolean}
         */
        showTheEarlierTheCheaper: function () {
            // eslint-disable-next-line no-undef
            return _.filter(this.domesticRateInfoArr, rate => rate.regionFreight !== 0).length > 0
        }
    }
}
</script>

<style scoped>
.range-where h3 {
    font-size: 1.143em;
    color: #ec2200;
}

.ui-collapsible {
    margin-bottom: 10px;
}
.express-list {
    border-top: 0;
}
.express-type-freight {
    padding: 10px;
}
.express-type-freight-arrive {
    padding: 0 10px;
}
.clearfix {
    zoom: 1;
}
.ui-collapsible-heading {
    background-color: #f8f8f8;
    border-top: #ddd 1px solid;
    border-bottom: #ddd 1px solid;
    padding: 10px;
    display: block;
    min-height: 25px;
    overflow: hidden;
}
.function-list {
    border-top: 0;
    border-bottom: #ddd 1px solid;
}
.function-list li:first-child {
    border-top: 0;
}
.function-list li {
    background-color: #fff;
    border-top: 0;
    border-bottom: #ddd 1px solid;
}
.type {
    display: inline-block;
    float: left;
    color: #333;
    word-break: break-all;
}
.express-type-freight .type:nth-of-type(1) {
    width: 30%;
}
.express-type-freight .type:nth-of-type(2) {
    width: 20%;
}
.express-type-freight .type:nth-of-type(3) {
    width: 30%;
}
li {
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    outline: none;
}
span {
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    outline: none;
}
.icon-pay-conver {
    position: relative;
    z-index: 0;
    display: block;
    min-height: 16px;
    color: #a9a9a9;
    font-size: 0.857em;
}
span {
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    outline: none;
}
.express-type-freight .cursor {
    outline: none;
    cursor: pointer;
}
.icon-pay-conver:before {
    content: '\e058';
    color: #a9a9a9;
    font-size: 18px;
}
</style>



// WEBPACK FOOTER //
// src/pages/payFee/pay-fee-result.vue